module.exports = __webpack_public_path__ + "img/logo_square_fundaztic.0a646327.png";